import { useState } from 'react';
import { Moon, Sun } from 'lucide-react';

function currentTheme(): 'dark' | 'light' {
  return document.documentElement.classList.contains('light') ? 'light' : 'dark';
}

/** Bascule sombre/clair : classe `light` sur <html> + mémorisation locale. */
export function ThemeToggle({ compact = false }: { readonly compact?: boolean }) {
  const [theme, setTheme] = useState<'dark' | 'light'>(currentTheme());

  function toggle() {
    const next = theme === 'dark' ? 'light' : 'dark';
    document.documentElement.classList.toggle('light', next === 'light');
    try {
      localStorage.setItem('bo-theme', next);
    } catch {
      /* stockage indisponible : le choix vaut pour la session */
    }
    setTheme(next);
  }

  return (
    <button
      type="button"
      onClick={toggle}
      className={`btn-ghost ${compact ? 'justify-center' : 'justify-center lg:justify-start'} w-full`}
      title={theme === 'dark' ? 'Passer en mode clair' : 'Passer en mode sombre'}
    >
      {theme === 'dark' ? (
        <Sun className="h-4 w-4 shrink-0" />
      ) : (
        <Moon className="h-4 w-4 shrink-0" />
      )}
      {!compact && (
        <span className="hidden lg:inline">{theme === 'dark' ? 'Mode clair' : 'Mode sombre'}</span>
      )}
    </button>
  );
}
